import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent, {AjaxParam} from '@components/base/BaseComponent/BaseComponent';

import Stars from "../../common/primitives/Stars";
import Button from "../../common/primitives/Button";
import PromoPrice from "../../common/primitives/PromoPrice";
import SharedHostingFeatures from "../../common/primitives/SharedHostingFeatures";

import hostingBoxStyles from "../../common/scss/HostingBox.scss";
import styles from './ComponentSuperStartBox.scss';

import ssImg from '../../../img/Hosting_Plans/ss_icon.svg';
import ssWPImg from '../../../img/Hosting_Plans/wp_ss_icon.svg';
import LoadingRow from "../../common/primitives/LoadingRow";
import {ContextDataStore} from "@helpers/HelperGlobalDataStore";
import PromoPriceYearly from "../../common/primitives/PromoPriceYearly";
//import ComponentDiscountSumAnimals from "../ComponentDiscountSumAnimals/ComponentDiscountSumAnimals";
import DiscountTag2022 from "../../common/primitives/DiscountTag2022/DiscountTag2022";
import buttons from "../../common/primitives/Button.scss";
import {__t} from '../../common/lang/text-resource';
import ButtonNew from "../../common/primitives/ButtonNew/ButtonNew";

class ComponentSuperStartBox extends BaseComponent {

	getComponentState = () => {
		const {
			servicePriceId,
			promoCode,
			addSEO,
			fromExclusiveOffer,
			fromExclusiveOfferWP,
			term
		} = this.state.componentData;

		return {
			servicePriceId: servicePriceId,
			promoCode: promoCode,
			addSEO: addSEO,
			fromExclusiveOffer: fromExclusiveOffer,
			fromExclusiveOfferWP: fromExclusiveOfferWP,
			term: term,
			planId: 'plan_01'
		};
	};

	addToCart = () => {
		const {
			servicePriceId,
			promoCode,
			addSEO,
			fromExclusiveOffer,
			fromExclusiveOfferWP
		} = this.state.componentData;

		const actionData = {
			servicePriceId: servicePriceId,
			promoCode: promoCode,
			addSEO: addSEO,
			fromExclusiveOffer: fromExclusiveOffer,
			fromExclusiveOfferWP: fromExclusiveOfferWP
		};
		let ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = () => {
			this.setState(this.state);
			this.eventRaise('ServiceAddedToCart', {serviceId: 'plan_01'});
		};
		this.ajaxCall('ActionAddToCart', actionData, ajaxParam)
	};

	// noinspection JSUnusedGlobalSymbols
	eventConsume(actionName, actionObject) {
		if (actionName === 'ServiceAddedToCart') {
			if ((actionObject.serviceId === 'plan_01')) {
				this.reload({});
			}
		}
	}

	render() {
		if (!this.state.componentData) {
			return '';
		}
		let {
			monthlyPriceOld,
			monthlyPriceNew,
			yearlyPrice,
			currency,
			servicePriceId,
			inCart,
			discountSum,
			discountPercent,
			fromExclusiveOffer,
			fromExclusiveOfferWP,
			term
		} = this.state.componentData;

		let isInCart = inCart;
		let cart = this.context.get('ComponentCart').componentData;
		if (cart) {
			let sIds = cart.onlyNewServices;
			isInCart = false;
			if (sIds['plan_01']) {
				isInCart = true;
			}
		}
		inCart = isInCart;
		if (this.props.disabledOff) {
			inCart = false;
		}

		const mainFeatures = [
			__t('15 GB пространство'),
			__t('~ 12 000 посещения/мес.'),
			__t('Неограничен трафик')
		];
		const secondaryFeatures = [
			__t('Сървърна мощ x 1'),
			__t('6 Backups + Professional Restore'),
		];

		let addToCart = this.addToCart;
		if (typeof this.props.addToCart === 'function') {
			addToCart = this.props.addToCart;
		}

		let continueSS = this.continueSS;
		if (typeof this.props.continueSS === 'function') {
			continueSS = this.props.continueSS;
		}

		let lang = SHVO.pageLang ?? 'bg';

		return (
		  <section className={hostingBoxStyles.container}>
			  <div className={`${hostingBoxStyles.header} ${styles.header}`}>
				  <img src={this.props.isWP ? ssWPImg : ssImg} alt={__t("СуперСтарт")}/>
			  </div>
			  <div className={hostingBoxStyles.body}>
				  <h1>{__t('СуперСтарт')}</h1>
				  <div className={hostingBoxStyles.purpose}>{__t('Най-подходящ за личен блог или сайт')}</div>

				  <SharedHostingFeatures mainFeatures={mainFeatures} isMain={true}/>

				  <Stars count={1} className={styles.stars}/>

				  <SharedHostingFeatures mainFeatures={secondaryFeatures} isMain={false}/>

				  {discountPercent > 0 ?
					<DiscountTag2022
					  top={-25}
					  right={-21}
					  bottom={0}
					  left={0}
					  rotate={-20}
					  value={discountPercent}
					  imageVariant={lang === 'en' ? 'percent-new-offer-en' : 'percent-new-offer'}
					  addPercent={true}
					/> : ''}

				  {/*<ComponentDiscountSumAnimals planId={'plan_01'} value={discountSum} currency={currency}/>*/}

				  {
					  this.props.withYearlyPrice === true ?
						<PromoPriceYearly yearlyPrice={yearlyPrice} oldPrice={monthlyPriceOld}
						                  newPrice={monthlyPriceNew} currency={currency}/>
						:
						<PromoPrice oldPrice={monthlyPriceOld} newPrice={monthlyPriceNew} currency={currency}/>
				  }

				  {
					  (this.loading) ?
						<div className={hostingBoxStyles.loadingImg}>
							<LoadingRow/>
						</div> :
						<div className={styles.buttonContainer}>
							<ButtonNew
							  onClick={() => addToCart(servicePriceId)}
							  name={'do_order_for_year_start'}
							  value={__t('Добави и продължи')}
							  disabled={inCart}/>
						</div>
				  }

				  {
					  (fromExclusiveOffer === true || fromExclusiveOfferWP === true) ?
						(term === 1) ?
						  <div>
							  <br/>
							  <Button
								onClick={continueSS}
								className={`${buttons.buttonLink} ${buttons.action}`}
								name={'do_continue_ss'}
								value={__t(`Продължи с поръчката на СуперСтарт :term месец`, {term: term})}/>
						  </div>
						  :
						  <div>
							  <br/>
							  <Button
								onClick={continueSS}
								className={`${buttons.buttonLink} ${buttons.action}`}
								name={'do_continue_ss'}
								value={__t(`Продължи с поръчката на СуперСтарт :term месеца`, {term: term})}/>
						  </div> : ''
				  }
			  </div>
		  </section>
		);
	}
}

ComponentSuperStartBox.defaultProps = {
	isWP: false,
	disabledOff: false
}
ComponentSuperStartBox.propTypes = {
	addToCart: PropTypes.func,
	continueSS: PropTypes.func,
	withYearlyPrice: PropTypes.bool,
	isWP: PropTypes.bool,
	disabledOff: PropTypes.bool
};


// React Context binding
ComponentSuperStartBox.contextType = ContextDataStore;

export default ComponentSuperStartBox;
